import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/home/rizoa/workd/project-2025/LUME_N_CO/101RED/node_modules/.c12/gitlab_ikamai_nuxt_TrAk1AWn9h/layouts/admin.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/rizoa/workd/project-2025/LUME_N_CO/101RED/node_modules/.c12/gitlab_ikamai_nuxt_TrAk1AWn9h/layouts/default.vue").then(m => m.default || m))
}